import { Card, CardContent } from '@mui/material'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

class ProfileCard extends Component {
    render() {
        const clickable = this.props.onClick ? 'clickable' : ''
        return (
            <Card onClick={ this.props.onClick } className={clickable} sx={{ width: '100%' }}>
                <CardContent>
                    { this.props.children }
                </CardContent>
            </Card>
        )
    }
}

ProfileCard.propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.element.isRequired,
}

export default ProfileCard
